module.exports = __webpack_public_path__ + "img/Costa_HMS_banner.698c52c8.png";